import ChallengeRepository from "../ChallengeRepository";
import Challenge, { Solution } from "../Challenge";
import Game from "../../game/Game";
import GameRepository from "../../game/GameRepository";
import LeaderboardRepository from "../../leaderboard/LeaderboardRepository";
import ResearchDataRepository from "../../research_data/ResearchDataRepository";


export default class ApplyCommand {

    constructor(
        private gameRepository: GameRepository,
        private challengeRepository: ChallengeRepository,
        private leaderboardRepository: LeaderboardRepository,
        private researchDataRepository: ResearchDataRepository,
        private challenge: Challenge,
        private game: Game,
        private solution: Solution
    ) {

    }

    public async execute(): Promise<void> {
        const score = await this.challengeRepository.findSolutionScore(this.solution.id);

        this.challenge.applySolution(this.solution.id, score)
        this.game.addScore(score)
        this.game.addChallengePlayed(this.challenge.challengeBlueprintId)
        await this.challengeRepository.update(this.challenge)
        await this.gameRepository.update(this.game)
        await this.leaderboardRepository.assignScoreAndGamesPlayedNum(
            this.game.sessionId,
            this.game.id, this.game.score, this.game.challengesPlayedNum)

        let solution_pos = 0;

        for (var solution of this.challenge.solutions) {
            solution_pos++;
            if (solution.id === this.solution.id) {
                break;
            }
        }

        var researchData = {
            session_id: this.game.sessionId,
            student: this.game.user?.user_name!,
            treatment: this.game.treatment!,
            issue: this.challenge.title,
            action: "apply",
            action_seq: this.challenge.currentActionIndex.toString(),
            solution: this.solution.id,
            solution_pos: solution_pos.toString(),
            timestamp: new Date()
        }

        this.researchDataRepository.insert(researchData)
    }
}